import StandardConfigure from "./standard/StandardConfigure";
import StandardShoot from "./standard/StandardShoot";
import DuelingConfigure from "./duelingTree/DuelingConfigure";
import DuelingShoot from "./duelingTree/DuelingShoot";
import MovingConfigure from "./moving/MovingConfigure";
import MovingShoot from "./moving/MovingShoot"


const standard = {
    name: "표준 표적 사격",
    description: "고정된 거리를 제공할 수 있는 옵션이 있는 표준 표적",
    configureComponent: StandardConfigure,
    shootComponent: StandardShoot
}

const duelingTree = {
    name: "듀얼링 트리",
    description: "친구와 경쟁하거나 혼자서 강철 플레이트를 쏘세요.",
    configureComponent: DuelingConfigure,
    shootComponent: DuelingShoot
}

const moving = {
    name: "움직이는 표적",
    description: "화면을 가로지르며 움직이는 과녁 표적을 맞추세요.",
    configureComponent: MovingConfigure,
    shootComponent: MovingShoot
}

const comingSoon = {
    name: "Coming Soon...",
    description: "아마도 정말 멋진 것일 겁니다.",
    configureComponent: null,
    shootComponent: null
}

export const shootingModes = [standard, duelingTree, moving, comingSoon]